import * as React from "react";
import { SVGProps } from "react";
const SvgMenuSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 15h16a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2Zm0 6h16a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2ZM8 9h16a1 1 0 1 1 0 2H8a1 1 0 0 1 0-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMenuSmall;
